import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { useId } from 'react';

export function LocationExpansionField({
  checked,
  onCheckedChange,
  disabled,
  legacyDefault = false,
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  legacyDefault?: boolean;
}) {
  const id = useId();
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-4">
        <Label htmlFor={id} className="text-sm leading-snug">
          Reach more people likely to respond to your ads
        </Label>
        <Switch
          id={id}
          checked={checked}
          onCheckedChange={onCheckedChange}
          disabled={disabled}
          aria-describedby={`${id}-description`}
        />
      </div>
      <p id={`${id}-description`} className="text-xs text-muted-foreground">
        Allow Meta to also reach people interested in your selected cities or
        regions. This applies to city and region targets; map-pin radius targets
        are unaffected.
        {legacyDefault &&
          ' No preference is saved for this campaign. Showing Meta’s default (on); save a change to apply your choice.'}
      </p>
    </div>
  );
}
